/* eslint-disable @typescript-eslint/no-empty-interface */
import * as React from 'react';

import { TextWithLinkContainer } from '../PopupWithForm/TextWithLink';

export interface IPopupWithComplaintProps {}

export class PopupWithComplaint extends React.PureComponent<IPopupWithComplaintProps, {}> {
  public render() {
    return <TextWithLinkContainer />;
  }
}
